export default "__VITE_ASSET__PUU0jEVT__";